import { createContext } from "react";
const initialState = {
    theme: "system",
    resolvedTheme: "light",
    setTheme: () => null,
};
export const ThemeProviderContext = createContext(initialState);
//# sourceMappingURL=theme-context.js.map